import { Directive, ElementRef, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { InquiriesRouteType, OrderRouteType } from '../../../core/enums/route-types.enum';

@Directive({ selector: '[appActivatePricelist]' })
export class ActivatePricelistDirective implements OnInit, OnDestroy {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private elRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  private subscription: Subscription;

  ngOnInit(): void {
    this.subscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data),
      )
      .subscribe((event) => {
        if (event.id in OrderRouteType || event.id === InquiriesRouteType.CMPR_VIEW) {
          this.renderer.addClass(this.elRef.nativeElement, 'dropdown--disabled');
        } else {
          this.renderer.removeClass(this.elRef.nativeElement, 'dropdown--disabled');
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
